(function () {
  if (window.__hfComplementaryInit) return;
  window.__hfComplementaryInit = true;

  var __thisSrc = (document.currentScript && document.currentScript.src) || '';
  var __carouselSrc = __thisSrc ? __thisSrc.replace(/[^\/]+$/, 'hf-carousel.js') : '';

  function loadCarouselThen(cb) {
    if (window.HfCarousel) return cb();
    var existing = document.querySelector('script[data-hf-carousel-loader]');
    if (existing) {
      existing.addEventListener('load', cb, { once: true });
      return;
    }
    if (!__carouselSrc) return;
    var s = document.createElement('script');
    s.src = __carouselSrc;
    s.dataset.hfCarouselLoader = 'true';
    s.async = false;
    s.onload = cb;
    document.head.appendChild(s);
  }

  function initRoot(root) {
    if (root.__hfInit) return;
    var el = root.querySelector('.hf-complementary-carousel');
    if (!el) return;
    var track = el.querySelector('.hf-carousel__track');
    var list = el.querySelector('.hf-carousel__list');
    if (!track || !list) return;
    root.__hfInit = true;

    var bar  = root.querySelector('.hf-slider-progress__bar');
    var prev = root.querySelector('.slider-button--prev');
    var next = root.querySelector('.slider-button--next');

    var n = list.querySelectorAll('.hf-carousel__slide').length;
    if (!n) return;

    var PVD = parseFloat(root.dataset.perView);
    var PVM = parseFloat(root.dataset.perViewMobile);
    var AUTOPLAY = root.dataset.autoplay === 'true';
    var SPEED = parseFloat(root.dataset.autoplaySpeed || '5') * 1000;

    function updateBar(idx, total) {
      if (!bar || total < 2) return;
      bar.style.width = ((idx + 1) / total * 100) + '%';
    }

    if (el._hfCarousel) { try { el._hfCarousel.destroy(); } catch (e) {} }
    if (el._hfIO) { try { el._hfIO.disconnect(); } catch (e) {} el._hfIO = null; }

    var canLoop = n > Math.min(PVD, PVM);

    var carousel = window.HfCarousel(track, {
      loop: canLoop,
      align: 'start',
      duration: 400,
      watchDrag: canLoop,
      perView: Math.max(PVD, PVM),
      autoplay: AUTOPLAY && canLoop ? {
        delay: SPEED,
        stopOnInteraction: true,
        stopOnMouseEnter: true,
      } : null,
    });

    if (!carousel) return;
    el._hfCarousel = carousel;

    carousel.on('init', function () {
      updateBar(carousel.selectedScrollSnap(), n);
    });
    carousel.on('select', function () {
      updateBar(carousel.selectedScrollSnap(), n);
    });
    carousel.on('resize', function () {
      try { carousel.reInit(); } catch (e) {}
    });

    updateBar(carousel.selectedScrollSnap(), n);

    if (prev) prev.addEventListener('click', function () { carousel.scrollPrev(); });
    if (next) next.addEventListener('click', function () { carousel.scrollNext(); });

    if (AUTOPLAY && canLoop && 'IntersectionObserver' in window) {
      var apPlugin = carousel.plugins().autoplay;
      if (apPlugin) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0]) return;
          if (entries[0].isIntersecting) apPlugin.play(); else apPlugin.stop();
        }, { threshold: 0.15 });
        io.observe(root);
        el._hfIO = io;
      }
    }
  }

  function tryInit(root) {
    if (!root.querySelector('.hf-complementary-carousel')) return;
    loadCarouselThen(function () { initRoot(root); });
  }

  function reset(root) {
    var el = root.querySelector('.hf-complementary-carousel');
    if (el && el._hfCarousel) {
      try { el._hfCarousel.destroy(); } catch (e) {}
      el._hfCarousel = null;
    }
    if (el && el._hfIO) {
      try { el._hfIO.disconnect(); } catch (e) {}
      el._hfIO = null;
    }
    root.__hfInit = false;
  }

  function whenVisible(el, cb) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) {
        io.disconnect();
        cb();
      }
    }, { rootMargin: '200px' });
    io.observe(el);
  }

  function bindAll(scope) {
    (scope || document).querySelectorAll('.hf-complementary-block[data-block-id]').forEach(function (root) {
      whenVisible(root, function () {
        tryInit(root);
        var prEl = root.querySelector('product-recommendations');
        if (prEl && !prEl.__hfBound) {
          prEl.__hfBound = true;
          prEl.addEventListener('recommendations:loaded', function () {
            reset(root);
            tryInit(root);
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindAll(document); });
  } else {
    bindAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindAll(event.target);
  });
})();
